module.exports = __webpack_public_path__ + "static/media/Att-2.ffb32096.png";